export const wrapStyle = {
	padding: '14px 24px'
};
